<template>
  <Modal
    class="change-price-ex-dlg"
    v-model="show"
    title="修改价格"
    width="650"
    @on-visible-change="onVisibleChange"
  >
    <p class="vmiddle">
      <Icon type="md-information-circle" size="20" color="#f49015" style="margin-right:10px;" />
      <span>仅支持对待支付的订单进行改价，改价后需要通知买家刷新订单页面核实价格</span>
    </p>
    <div class="content">
      <Table :columns="tableColumns" :data="tableDatas"></Table>
    </div>
    <div class="content">
      <Form ref="form" :model="form" :rules="rules" :label-width="110">
        <FormItem label="加/减价(元)：" prop="adjust_order_price">
          <InputNumber class="com-width" v-model="form.adjust_order_price" placeholder="请输入加/减价格"></InputNumber>
        </FormItem>
        <FormItem v-if="hasLogistics" label="运费(元)：" prop="adjust_logistics_price">
          <InputNumber
            class="com-width"
            :min="0"
            v-model="form.adjust_logistics_price"
            placeholder="请输入运费价格"
          ></InputNumber>
        </FormItem>
        <FormItem label="实付金额(元)：">{{realPrice}}</FormItem>
      </Form>
    </div>
    <div slot="footer" style="text-align:center;">
      <Button type="primary" @click="onOk" size="large" style="width:100px;">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: "change-price-ex-dlg",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      required: true
    },
    // 是否有运费
    hasLogistics: {
      default: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.show = val;
      }
    },
    show(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    realPrice() {
      let ret = this.orderPrice;
      ret += this.form.adjust_order_price || 0;
      if (this.hasLogistics) {
        ret += this.form.adjust_logistics_price || 0;
      }
      return Number(ret).toFixed(2);
    }
  },
  data() {
    return {
      show: false,
      tableColumns: [
        { title: "商品", key: "product_name", align: "center" },
        { title: "单价(元)", key: "product_price_show", align: "center" },
        { title: "数量", key: "product_number", align: "center" },
        { title: "小计(元)", key: "total_price_show", align: "center" }
      ],
      tableDatas: [],
      form: {
        adjust_order_price: null,
        adjust_logistics_price: null
      },
      rules: {
        adjust_order_price: [
          {
            required: true,
            type: "number",
            message: "请输入加/减价格",
            trigger: "blur"
          }
        ],
        adjust_logistics_price: [
          {
            required: true,
            type: "number",
            message: "请输入运费价格",
            trigger: "blur"
          }
        ]
      },
      orderPrice: 0 // 小计价格的总和
    };
  },
  created() {},
  methods: {
    // on event
    onVisibleChange(val) {
      if (val) this.requestData();
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        // 如果没有运费，不传运费参数
        const params = Object.assign({}, this.form);
        if (!this.hasLogistics) {
          delete params.adjust_logistics_price;
        }
        this.$http
          .put(`/api/order/adjustment/${this.orderId}`, params)
          .then(() => {
            this.$Message.success("改价成功");
            this.show = false;
            this.$emit("on-ok");
          });
      });
    },
    // request
    requestData() {
      this.$pub.clearObj(this.form, [], null);
      this.$http
        .get(`/api/order/adjustmentOrder/${this.orderId}`)
        .then(data => {
          // 计算商品显示价格
          data.order_item.forEach(i => {
            i.product_price_show = this.$pub.calcPrice(i.product_price);
            i.total_price_show = this.$pub.calcPrice(
              i.product_price * i.product_number
            );
          });
          this.tableDatas = data.order_item;
          // 初始化运费
          this.form.adjust_logistics_price = +this.$pub.calcPrice(
            data.order_info.logistics_fee
          );
          this.orderPrice = +this.$pub.calcPrice(data.order_info.order_price);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>